import React from "react";
import Box from "@amzn/meridian/box";
import Divider from "@amzn/meridian/divider";
import Row from "@amzn/meridian/row";
import { ICardInfoProps } from "./definitions";
import Badge from "@amzn/meridian/badge";
import Link from "@amzn/meridian/link";

export const CardInfo: React.FC<ICardInfoProps> = ({
    title,
    unreadCount,
    overdueCount,
    openCount,
    link,
}) => {
    return (
        <>
            <Divider />

            <Row widths={["fill"]} spacingInset={"200"}>
                <Box>
                    <Link type="secondary" href={link}>
                        {title}{" "}
                    </Link>
                </Box>
                {overdueCount && <Badge type={"error"} value={overdueCount} maxValue={99} />}
                {unreadCount && <Badge value={unreadCount} maxValue={99} />}
                {openCount && <Badge type={"neutral"} value={openCount} maxValue={99} />}
            </Row>
        </>
    );
};
